<template>
    <div class="vue-friendly-iframe"></div>
</template>

<script type="text/jsx">
    import uuidV1 from 'uuid/v1';

    // borrowed from David Walsh : https://davidwalsh.name/javascript-debounce-function
    function debounce (func, wait, immediate) {
        let timeout;
        return function () {
            const context = this;
            const args = arguments;
            const later = function () {
                timeout = null;
                if (!immediate) {
                    func.apply(context, args);
                }
            };
            const callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) {
                func.apply(context, args);
            }
        };
    };

    function generateGuid () {
        return uuidV1();
    };

    export default {
        // borrowed from Tim Officer : https://github.com/officert/vue-friendly-iframe
        name: "friendly-iframe",
        props: {
            src: {
                type: String,
                required: true
            },
            className: {
                type: String,
                required: false
            },
            scrolling: {
                type: String,
                required: false,
                default: 'no'
            }
        },
        data: function () {
            return {
                iframeEl: null,
                iframeLoadedMessage: `IFRAME_LOADED_${generateGuid()}`,
                iframeOnReadyStateChangeMessage: `IFRAME_ON_READ_STATE_CHANGE_${generateGuid()}`
            };
        },
        watch: {
            src: function () {
                this.reinitIframe(this);
            }
        },
        methods: {
            removeIframe: function () {
                while (this.$el.firstChild) {
                    this.$el.removeChild(this.$el.firstChild);
                }
            },
            setIframeUrl: function () {
                const iframeDoc = this.iframeEl.contentWindow.document;
                const locHref = this.src.replace(/'/g, "\\'");
                iframeDoc.open().write(`
                    <body onload="window.location.href='${locHref}'; parent.postMessage('${this.iframeLoadedMessage}', '*')"></body>
                    <script>
                        window.document.onreadystatechange = function () {
                            if (window.document.readyState === 'complete') {
                                parent.postMessage('${this.iframeOnReadyStateChangeMessage}', '*')
                            }
                        };
                    <\/script>
                `);
                iframeDoc.close(); // iframe onload event happens
            },
            reinitIframe: debounce(vm => {
                vm.removeIframe();
                vm.initIframe();
            }, 200),
            initIframe: function () {
                this.iframeEl = document.createElement("iframe");
                this.iframeEl.setAttribute("crossorigin", "anonymous");
                this.iframeEl.setAttribute("target", "_parent");
                this.iframeEl.setAttribute(
                    "style",
                    "visibility: hidden; position: absolute; top: -99999px"
                );
                this.iframeEl.setAttribute("marginwidth", "0");
                this.iframeEl.setAttribute("marginheight", "0");
                this.iframeEl.setAttribute("frameborder", "0");
                this.iframeEl.setAttribute("scrolling", this.scrolling);
                if (this.className) {
                    this.iframeEl.setAttribute("class", this.className);
                }
                this.$el.appendChild(this.iframeEl);
                this.setIframeUrl();
            },
            listenForEvents: function () {
                // Create IE + others compatible event handler
                const eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
                const eventer = window[eventMethod];
                const messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message";
                // Listen to message from child window
                eventer(
                    messageEvent,
                    event => {
                        if (event.data === this.iframeLoadedMessage) {
                            this.$emit("iframe-load");
                            this.iframeEl.setAttribute("style", "visibility: visible;");
                        }
                        if (event.data === this.iframeOnReadyStateChangeMessage) {
                            this.$emit("document-load");
                            this.$emit("load");
                        }
                    },
                    false
                );
            }
        },
        mounted: function () {
            this.listenForEvents();
            this.initIframe();
        }
    };
</script>



// WEBPACK FOOTER //
// friendly-iframe.vue?1f4b5e90